var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_618_2267)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.291077,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#D5F0F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_2267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1167 18.3661L21.2833 16.9827C21.1083 16.6744 20.95 16.0911 20.95 15.7494V13.6411C20.949 12.7111 20.6847 11.8004 20.1877 11.0144C19.6907 10.2284 18.9814 9.59909 18.1417 9.19941C17.9273 8.81886 17.6147 8.50286 17.2365 8.28444C16.8583 8.06602 16.4284 7.95319 15.9917 7.95774C15.0833 7.95774 14.2667 8.44941 13.8333 9.22441C12.2083 10.0327 11.0833 11.7077 11.0833 13.6411V15.7494C11.0833 16.0911 10.925 16.6744 10.75 16.9744L9.90833 18.3661C9.57499 18.9244 9.49999 19.5411 9.70833 20.1077C9.90833 20.6661 10.3833 21.0994 11 21.3077C12.6167 21.8577 14.3167 22.1244 16.0167 22.1244C17.7167 22.1244 19.4167 21.8577 21.0333 21.3161C21.6167 21.1244 22.0667 20.6827 22.2833 20.1077C22.5 19.5327 22.4417 18.8994 22.1167 18.3661ZM18.3583 22.9661C18.1831 23.4512 17.8627 23.8706 17.4408 24.1673C17.0189 24.464 16.5158 24.6236 16 24.6244C15.3417 24.6244 14.6917 24.3577 14.2333 23.8827C13.9667 23.6327 13.7667 23.2994 13.65 22.9577C13.7583 22.9744 13.8667 22.9827 13.9833 22.9994C14.175 23.0244 14.375 23.0494 14.575 23.0661C15.05 23.1077 15.5333 23.1327 16.0167 23.1327C16.4917 23.1327 16.9667 23.1077 17.4333 23.0661C17.6083 23.0494 17.7833 23.0411 17.95 23.0161L18.3583 22.9661Z",
    fill: "#0B2239"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10.2911,
    r: 4,
    fill: "#FF5757",
    stroke: "#D5F0F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_618_2267",
    x: -100,
    y: -99.7089,
    width: 232,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_618_2267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_618_2267",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_2267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.29108)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.fcc91815d8751fd7276e33689cf91520.svg";
export { ForwardRef as ReactComponent };